<template>
  <div class="flex flex-col p-1 rounded-lg bg-neutral-800 shadow-lg w-max">
    <button v-if="advertiserId" class="group flex items-center gap-2 p-1.5 rounded-md transition-colors hover:bg-neutral-700"
    :class="{ 'cursor-default': loading }" @click="viewBrandInSpyder">
      <div v-if="loading" class="h-6 w-6 flex items-center justify-center text-white">
        <BaseLoadingSpinnerCircle />
      </div>
      <img v-else src="../../assets/icons/spyder.png" class="h-6 w-6" style="border-radius: 4.5px;" />
      <BaseText type="label" size="sm" class="transition text-white text-opacity-90 group-hover:text-opacity-100">
        See All Ads
      </BaseText>
      <div class="ml-auto transform -rotate-90">
        <ChevronIcon className="text-neutral-300 transition-colors group-hover:text-white group-hover:text-opacity-90" />
      </div>
    </button>
    <BaseText v-else type="body" size="sm" class="p-1.5 text-neutral-200">
      This ad is not associated with a brand
    </BaseText>
  </div>
</template>

<script>
import ForeplayAPI from '@/api/foreplayServer'
import ChevronIcon from '../globals/Icons/ChevronIcon.vue'

export default {
  name: 'BrandActionsTooltip',
  components: {
    ChevronIcon
  },
  props: {
    // Meta ad library page id of the ad's brand
    advertiserId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      loading: false,
      dismissed: false
    }
  },
  beforeDestroy () {
    this.dismissed = true
  },
  methods: {
    async viewBrandInSpyder () {
      if (this.loading) return
      this.loading = true
      try {
        const brand = await ForeplayAPI.Brands.getByAdvertiserId(this.advertiserId)
        // The popup was closed while the brand was loading
        if (this.dismissed) return
        if (!brand) {
          this.$showAlert({ type: 'error', message: 'This brand isn\'t available in Spyder yet.' })
          return
        }
        if (this.$route.name === 'SpyderView' && this.$route.params.id === brand.id) {
          this.$emit('close')
          return
        }
        this.$router.push({ name: 'SpyderView', params: { id: brand.id } })
      } catch (error) {
        console.error('Error fetching spyder brand', error)
        this.$showAlert({ type: 'error', message: 'Error loading brand.' })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
